import { useEffect, useState } from "react";
import { api, reelThumbnail } from "../lib/api";
import { Play } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function SolutionsInMotion() {
  const [reels, setReels] = useState([]);
  useEffect(() => {
    api.get("/reels").then(({ data }) => setReels(data)).catch(() => {});
  }, []);

  return (
    <section data-testid="solutions-in-motion" className="px-6 md:px-14 py-24 md:py-32 border-b border-[#2A2A2A]">
      <div className="flex items-end justify-between max-w-6xl gap-6">
        <div>
          <div className="text-overline mb-6">◢ Show, don't tell</div>
          <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl text-white leading-[1.05]">
            Solutions in <span className="text-[#FF4500]">motion</span>.
          </h2>
        </div>
        <Link to="/reels" data-testid="see-all-reels" className="btn-ghost hidden md:inline-flex">
          See all reels →
        </Link>
        <Link to="/live" data-testid="open-live-feed" className="btn-primary hidden md:inline-flex ml-2">
          ▶ Live feed
        </Link>
      </div>

      <div className="mt-14 overflow-x-auto -mx-6 md:-mx-14 px-6 md:px-14 pb-4" data-testid="reels-strip">
        <div className="flex gap-px bg-[#2A2A2A] border border-[#2A2A2A] w-fit">
          {reels.map((r) => (
            <Link
              to={`/reels/${r.slug || r.id}`}
              key={r.id}
              data-testid={`reel-${r.id}`}
              className="group relative w-[320px] md:w-[380px] aspect-[16/10] bg-[#050505] overflow-hidden ww-trace"
            >
              <img src={reelThumbnail(r)} alt={r.title} className="w-full h-full object-cover opacity-65 group-hover:opacity-85 group-hover:scale-105 transition-all duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent" />

              <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#DFFF00]">
                  {r.category}
                </span>
                <span className="font-mono text-[10px] text-[#8E8E93]">{r.duration_sec}s</span>
              </div>

              <div className="absolute bottom-4 left-4 right-4">
                <div className="font-display text-xl text-white">{r.title}</div>
                <div className="mt-1 text-[#8E8E93] text-sm line-clamp-2">{r.what_it_solves}</div>
                <div className="mt-3 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Play size={14} weight="fill" color="#FF4500" />
                  <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-white">Watch</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
